import { render, staticRenderFns } from "./NavStationItem.vue?vue&type=template&id=fa17f1e6&"
import script from "./NavStationItem.vue?vue&type=script&lang=js&"
export * from "./NavStationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports